export * from './seller-personal-data.component';
